// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7075":"fab72c70","9383":"fab72c70"}[chunkId] + ".chunk.css";
};